import { EEventActions } from '@/store/eventStore/EventStoreTypes'

export const eventsFr = {
    actions: {
        affectFilters: 'Affecter des filtres à cet évènement',
        affectFiltersTitle: 'Affecter des filtres',
        affectFiltersDevice: "Confirmer et affecter aux appareils de l'évènement",

        affectDevices: 'Affecter des filtres aux appareils de cet évènement',

        reinitializeFiltersDevicesTitle: 'Réinitialiser les filtres des appareils',
        reinitializeFiltersDevices: 'Sélectionner les appareils',
        reinitializeFiltersDevicesConfirmation:
            'Êtes-vous sûr de vouloir réinitaliser les filtres de ces appareils ? Cette action est irréversible.',

        guntime: {
            now: 'Maintenant',
            multipleGuntimes: 'Plusieurs guntime',
            name: 'Nom',
            startAt: 'Départ à',
            addGuntime: 'Ajouter un guntime supplémentaire',
            addGuntimeTitle: 'Créer des guntimes'
        }
    },
    api: {
        error: {
            [EEventActions.CREATE_EVENT]: "Erreur lors de la création de l'évènement {name}",
            [EEventActions.DELETE_EVENT]: "Erreur lors de la suppression de l'évènement {name}",
            [EEventActions.FETCH_EVENT]: "Erreur lors de la récupération de l'évènement",
            [EEventActions.FETCH_EVENTS]: 'Erreur lors de la récupération des évènements',
            [EEventActions.UPDATE_EVENT]: "Erreur lors de la modification de l'évènement {name}",

            [EEventActions.SET_EVENT_FILTERS]: "Erreur lors de l'affectation des filtres'",
            [EEventActions.SET_GUNTIME]: 'Erreur lors de la création du guntime',
            [EEventActions.SYNC_CHECKPOINTS]: 'Erreur lors de la synchronisation des checkpoints',
            [EEventActions.SET_CHECKPOINTS_POSITIONS]:
                "Erreur lors de la sauvegarde de l'ordre des checkpoints"
        },
        success: {
            [EEventActions.CREATE_EVENT]: "Création de l'évènement {name} effectuée avec succès !",
            [EEventActions.DELETE_EVENT]:
                "Suppression de l'évènement {name} effectuée avec succès !",
            [EEventActions.FETCH_EVENT]: "Récupération de l'évènement effectuée avec succès !",
            [EEventActions.FETCH_EVENTS]: 'Récupération des évènements effectuée avec succès !',
            [EEventActions.UPDATE_EVENT]:
                "Modification(s) de l'évènement {name} effectuée(s) avec succès !",

            [EEventActions.SET_EVENT_FILTERS]: 'Affectation des filtres effectuée avec succès !',
            [EEventActions.SET_GUNTIME]: 'Création du guntime effectuée avec succès !',
            [EEventActions.SYNC_CHECKPOINTS]:
                'Synchronisation des checkpoints effectuée avec succès !',
            [EEventActions.SET_CHECKPOINTS_POSITIONS]:
                "Sauvegarde de l'ordre des checkpoints effectuée avec succès !"
        }
    },
    createEvent: 'Créer un évènement',
    duplicatedEvent: 'Evènement dupliqué',
    button: {
        addCheckpoint: 'Ajouter un checkpoint',
        duplicateEvent: 'Dupliquer',
        editEvent: 'Editer',

        saveCheckpointOrder: "Sauvegarder l'ordre des checkpoints",
        editCheckpointOrder: "Editer l'ordre des checkpoints"
    },
    checkpoint: {
        name: 'Nom',
        comment: 'Commentaire',
        detections: 'Détections',
        devicesList: "Liste d'appareils",
        noDetectionFound: 'Aucune détection trouvée',
        noDeviceAssociated: 'Aucun appareil associé'
    },
    detail: {
        informations: {
            informationsTitle: 'Informations',
            eventLocalization: "Localisation de l'évènement",
            guntimes: 'Guntimes',
            editTitle: "Editer l'évènement",
            partnerConfigTitle: 'Configuration du partenaire',
            partnerConfigUpdate: 'Modification du partenaire'
        },
        checkpoints: {
            checkpointsTitle: 'Checkpoints',
            createCheckpointTitle: 'Créer un nouveau checkpoint',
            partner: 'Partenaire'
        },
        devices: {
            devicesTitle: 'Appareils'
        },
        stats: {
            checkpointsCount: 'Checkpoints',
            onlineDevicesCount: 'Appareils en ligne',
            readsCount: 'Détections'
        }
    },
    detection: {
        table: {
            bib: 'Bib',
            checkpoint: 'Checkpoint',
            timestamp: 'Date',
            device: 'Appareil',
            event_filter: 'Event filter',
            timer_filter: 'Timer filter'
        },
        liveDetections: 'Détections en direct',
        pastDetections: 'Détections précédentes'
    },
    filters: {
        archived: 'Archivé',
        clientId: 'ID du client',
        date_limit: 'Date',
        end_at: 'Date de fin',
        endAt: "Fin d'évènement",
        endDate: 'Date de fin',
        eventName: "Nom de l'évènement",
        field: 'Champ',
        future: 'Futur',
        past: 'Passé',
        period: 'Période',
        showFinished: 'Afficher les évènements terminés',
        showOngoing: 'Afficher les évènements en cours',
        showUpcoming: 'Afficher les évènements à venir',
        finished: 'Evènements terminés',
        ongoing: 'Evènements en cours',
        upcoming: 'Evènements à venir',
        start_at: "Début d'évènement",
        startAt: "Début d'évènement",
        startDate: 'Date de début'
    },
    model: {
        clientId: 'ID du client',
        eventId: 'Event ID Hub',
        comment: 'Commentaire',
        endAt: 'Date de fin',
        name: "Nom de l'évènement",
        currentPartner: 'Partenaire actuel',
        partnerName: 'Partenaire',
        partnerId: 'ID du partenaire',
        startAt: 'Date de début',
        tz: 'Timezone'
    },
    table: {
        clientId: 'ID du Client',
        comments: 'Commentaires',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        eventName: "Nom de l'évènement",
        duplicateEvent: 'Êtes-vous sûr(e) de vouloir dupliquer cet évènement ?',
        organizationName: 'Organisation'
    },
    title: {
        datesTitle: "Dates de l'évènement",
        actionsTitle: 'Actions'
    }
}
